import axios from "../utils/axios";

export default function fetchAcquiredJobs(adminId, params) {
    console.log("PARAMS: ", params)
  return axios.get("/admin/" + adminId + "/acquired-jobs", { params });
}
